import ContextModel from '../context/index.model.js';
import WidgetModel from '../widget/index.model.js';
const model = {
    name: 'SearchRequest',
    file: 'SearchRequest',
    buildInterface: true,
    properties: {
        context: { type: 'model', model: ContextModel },
        rfk_flags: { type: 'array', name: 'rfkFlags' },
        widget: { type: 'model', model: WidgetModel },
    },
};
export default model;
